function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 15px;\n  padding-bottom: 15px;\n\n  ",
        ";\n\n  padding-left: ",
        ";\n\n  label {\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { Component, Fragment } from "react";
import propTypes from "prop-types";
import styled from "styled-components";
import { withContext, context } from "../../../../wr-context";
import DropdownInput from "../../../../dropdown-input";
import Checkbox from "../../../../checkbox-group/checkbox";
import { orderCategories } from "../../../../../utils/categories";
import i18n from "../../../../../utils/i18n";
import mixpanel from "mixpanel-browser";
import { isAnalyticsEnabled } from "../../../../../modules/analytics";
var OptionWrapper = styled.div(_templateObject(), function(param) {
    var isSelected = param.isSelected, deselectableOptions = param.deselectableOptions;
    return isSelected && !deselectableOptions && "\n    pointer-events: none;\n    cursor: default;\n  ";
}, function(param) {
    var paddingLeft = param.paddingLeft;
    return paddingLeft || "20px";
}, function(param) {
    var theme = param.theme, isSelected = param.isSelected;
    var ref;
    return isSelected && "\n      color: ".concat((ref = theme.components.dropdownInput) === null || ref === void 0 ? void 0 : ref.selectedColor, "\n      cursor: default;\n    ");
});
var RenderOption = function(props) {
    var ref, ref1;
    /*#__PURE__*/ return React.createElement(Fragment, null, /*#__PURE__*/ React.createElement(Checkbox, {
        "data-testid": "product-list-category-checkbox",
        type: "checkbox",
        checked: props.isSelected,
        disabled: props.isSelected && !props.deselectableOptions,
        checkedDisabledColor: (ref = context.theme.components) === null || ref === void 0 ? void 0 : (ref1 = ref.dropdownInput) === null || ref1 === void 0 ? void 0 : ref1.selectedColor,
        onChange: function() {
            return null;
        }
    }), " ", /*#__PURE__*/ React.createElement("label", {
        "data-testid": "product-list-category-checkbox-label"
    }, props.label));
};
RenderOption.propTypes = {
    isSelected: propTypes.bool,
    label: propTypes.string
};
var CategoriesDropdown = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(CategoriesDropdown, Component);
    var _super = _createSuper(CategoriesDropdown);
    function CategoriesDropdown(props) {
        _classCallCheck(this, CategoriesDropdown);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            categoriesValue: []
        };
        _this.selectChildrenCategory = function(selectOption, child) {
            selectOption({
                label: child.name || "",
                value: child.id,
                id: child.id,
                parentCategoryId: child.parentCategoryId
            });
        };
        _this.selectMainCategory = function(hasChildren, option, getValue, setValue) {
            var newValue = getValue();
            if (newValue.filter(function(val) {
                return val.value === option.id;
            }).length) {
                newValue = newValue.filter(function(val) {
                    return val.value !== option.id;
                });
            } else {
                newValue.push(option);
            }
            if (hasChildren) {
                var childrens = context.state.categories.filter(function(categ) {
                    return categ.parentCategoryId === option.value;
                });
                childrens.forEach(function(child) {
                    var valueExists = newValue.filter(function(val) {
                        return val.value === child.id;
                    });
                    if (valueExists.length > 0) {
                        var valueIndex = newValue.findIndex(function(val) {
                            return val.value === child.id;
                        });
                        newValue = _toConsumableArray(newValue.slice(0, valueIndex)).concat(_toConsumableArray(newValue.slice(valueIndex + 1)), [
                            {
                                label: child.name || "",
                                value: child.id,
                                id: child.id,
                                parentCategoryId: child.parentCategoryId
                            }, 
                        ]);
                    } else {
                        newValue.push({
                            label: child.name || "",
                            value: child.id,
                            id: child.id,
                            parentCategoryId: child.parentCategoryId
                        });
                    }
                });
                setValue(newValue);
            }
        };
        _this.Option = function(props) {
            var data = props.data, _getValue = props.getValue, getValue = _getValue === void 0 ? function() {
                return [];
            } : _getValue, _setValue = props.setValue, setValue = _setValue === void 0 ? function() {
                return [];
            } : _setValue;
            var hasChildren = context.state.categories.filter(function(categ) {
                return categ.parentCategoryId === data.value;
            });
            var isChildren = data.parentCategoryId;
            if (isChildren) return null;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(OptionWrapper, {
                isSelected: props.isSelected,
                onClick: function() {
                    isAnalyticsEnabled() && mixpanel.track(context.constants.analytics.categoryFilterSelected, {
                        categoryName: data.label || data.name
                    });
                    _this.selectMainCategory(Boolean(hasChildren), data, getValue, setValue);
                },
                key: data.id,
                deselectableOptions: _this.props.deselectableOptions
            }, /*#__PURE__*/ React.createElement(RenderOption, _extends({}, props, {
                deselectableOptions: _this.props.deselectableOptions
            }))), hasChildren.length > 0 && hasChildren.map(function(child) {
                return _this.renderOptionChildren({
                    child: child,
                    props: props,
                    padding: 20
                });
            }));
        };
        _this.renderOptionChildren = function(param) {
            var child = param.child, _$props = param.props, padding = param.padding;
            var categorySelection = context.state.categoryFilters;
            var distance = padding + 20;
            var isSelected = context.state.categoryFilters.includes(child.id);
            var hasChildren = context.state.categories.filter(function(categ) {
                return categ.parentCategoryId === child.value;
            });
            var isChildrenSelected = categorySelection.filter(function(categ) {
                return categ === child.id;
            }).length > 0;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(OptionWrapper, {
                isSelected: isSelected,
                onClick: function() {
                    return _this.selectChildrenCategory(_$props.selectOption, child);
                },
                key: child.id,
                paddingLeft: "".concat(distance, "px"),
                deselectableOptions: _this.props.deselectableOptions
            }, /*#__PURE__*/ React.createElement(RenderOption, _extends({}, _$props, {
                deselectableOptions: _this.props.deselectableOptions,
                isSelected: isChildrenSelected,
                label: child.label,
                data: child,
                value: child.id
            }))), hasChildren.length > 0 && hasChildren.map(function(child) {
                return _this.renderOptionChildren({
                    child: child,
                    isSelected: isSelected,
                    props: _$props,
                    padding: distance
                });
            }));
        };
        _this.handleCategoriesChange = function(categories) {
            var _$context = _this.props.context;
            var categoryFilters = _$context.state.categoryFilters;
            if (!categories) {
                categories = [];
            }
            var categoriesId = categories.map(function(c) {
                return c.id;
            });
            categoriesId.filter(function(c) {
                return !categoryFilters.includes(c);
            }).forEach(function(cat) {
                return _$context.actions.updateCategoryFilters(cat);
            });
            categoryFilters.filter(function(f) {
                return !categoriesId.includes(f);
            }).forEach(function(cat) {
                return _$context.actions.updateCategoryFilters(cat);
            });
            _this.setState({
                categoriesValue: categories
            });
        };
        var categoryFilters = (props.resetSelectedCategories ? [] : props.context.state).categoryFilters;
        var categories = _this.props.categories || context.state.categories;
        var selectedCategories = (categoryFilters || []).map(function(id) {
            return categories.find(function(v) {
                return v.id === id;
            });
        });
        _this.state = {
            categoriesValue: _toConsumableArray(selectedCategories)
        };
        return _this;
    }
    var _proto = CategoriesDropdown.prototype;
    _proto.render = function render() {
        var _props = this.props, filterByCategoryLabel = _props.filterByCategoryLabel, context = _props.context, orderCategoriesAZ = _props.orderCategoriesAZ, orderCategoriesZA = _props.orderCategoriesZA, styles = _props.styles;
        var categories = this.props.categories || context.state.categories;
        var options = orderCategories(categories, orderCategoriesAZ, orderCategoriesZA);
        return /*#__PURE__*/ React.createElement(DropdownInput, {
            "data-test-id": "categories-dropdown",
            value: this.state.categoriesValue,
            onChange: this.handleCategoriesChange,
            options: options,
            className: "categories",
            classNamePrefix: "categories",
            placeholder: filterByCategoryLabel,
            closeMenuOnSelect: false,
            hideSelectedOptions: false,
            components: {
                Option: this.Option
            },
            menuPortalTarget: document.body,
            isMulti: true,
            large: true,
            fullWidth: true,
            styles: styles
        });
    };
    return CategoriesDropdown;
}(Component);
CategoriesDropdown.propTypes = {
    context: propTypes.shape({
        state: propTypes.shape({
            categoryFilters: propTypes.array,
            categories: propTypes.array
        }),
        actions: propTypes.shape({
            updateCategoryFilters: propTypes.func
        })
    }),
    filterByCategoryLabel: propTypes.string,
    categories: propTypes.array,
    orderCategoriesAZ: propTypes.bool,
    orderCategoriesZA: propTypes.bool,
    resetSelectedCategories: propTypes.bool,
    deselectableOptions: propTypes.bool
};
CategoriesDropdown.defaultProps = {
    filterByCategoryLabel: i18n("toolbar.filterByCategory"),
    orderCategoriesAZ: false,
    orderCategoriesZA: false,
    deselectableOptions: false
};
export default withContext(CategoriesDropdown);
